


































































































import Vue from 'vue'
import { fetchEntitlementById } from '../services/inventory-client'
import { EntitlementShowData } from '../types'
import ItemsTable from '../components/ItemsTable.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'

export default Vue.extend({
  name: 'EntitlementsShow',
  components: {
    ItemsTable,
    AppBackToListButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      entitlement: {} as any,
      showDetails: false
    }
  },
  computed: {
    isBehaviorsHasConsumable (): boolean {
      return this.entitlement.behaviors && this.entitlement.behaviors.includes('consumable')
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)

    fetchEntitlementById(this.id)
      .then((entitlement: EntitlementShowData) => {
        this.entitlement = entitlement
        this.showDetails = true
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.$store.commit('global/setLoading', false)
      })
  }
})
